// 2023.07.13 New Standard API
// import  _ from 'lodash'
import qs from 'qs'
import {$swoole} from './axios.setup'
// getStandards
export const getStandards = async ({params} = {}) => {
  try {
    const url = '/v1/cars'

    const res = await $swoole.get(url, {
      params,
    })

    if (!res) {
      return
    }

    if (res.status === 200) {
      if (res.data.status === 'success') {
        return res.data
      }
      else {
        throw new Error(res.data.message)
      }
    }
    else {
      throw new Error(res.status)
    }
  }
  catch (err) {
    alert(err.message || err )
  }
}

// getBrandsOfStandards
export const getBrandsOfStandards = async ({params} = {}) => {
  try {
    const url = '/v1/filter-param-brand-new'
    const res = await $swoole.get(url, {
      params,
    })

    if (!res) {
      return
    }

    if (res.status === 200) {
      if (res.data.status === 'success') {
        return res.data.data
      }
      else {
        throw new Error(res.data.message)
      }
    }
    else {
      throw new Error(res.status)
    }
  }
  catch (err) {
    alert(err.message || err)
  }
}

// getProvincesOfStandard
export const getProvincesOfStandard = async ({params} = {}) => {
  try {
    const url = '/v1/filter-param-province'
    const res = await $swoole.get(url, {
      params,
    })

    if (!res) {
      return
    }

    if (res.status === 200) {
      if (res.data.status === 'success') {
        return res.data.data
      }
      else {
        throw new Error(res.data.message)
      }
    }
    else {
      throw new Error(res.status)
    }
  }
  catch (error) {
    throw new Error(error)
  }
}

// getSubstationOfStandard
export const getSubstationOfStandard = async ({params} = {}) => {
  try {
    const url = '/v1/filter-param-substations'
    const res = await $swoole.get(url, {
      params,
    })

    if (!res) {
      return
    }

    if (res.status === 200) {
      if (res.data.status === 'success') {
        return res.data.data
      }
      else {
        throw new Error(res.data.message)
      }
    }
    else {
      throw new Error(res.status)
    }
  }
  catch (err) {
    alert(err.message || err)
  }
}

// getStandard
export const getStandard = async ({params} = {}) => {
  try {
    const url = `/v1/car/${params.id}`
    const res = await $swoole.get(url, {
      params,
    })

    if (!res) {
      return
    }

    if (res.status === 200) {
      if (res.data.status === 'success') {
        return res.data
      }
      else {
        throw new Error(res.status)
      }
    }
    else {
      throw new Error(res.status)
    }
  }
  catch (err) {
    alert(err.message || err)
  }
}

// retrieveStandardReportEquipment
export const retrieveStandardReportEquipment = async ({params}) => {
  try {
    const url = '/v1/car/configurationChecklist'
    const res = await $swoole.get(url, {
      params,
    })

    if (!res) {
      return
    }

    if (res.status === 200) {
      return res.data
    }
    else {
      throw new Error(res.status)
    }
  }
  catch (err) {
    alert(err.message || err)
  }
}

// getStandardRecommends
// - 2023.08.16
// - get standard recommends
export const getStandardRecommends = async ({params}) => {
  const url = '/v1/likes'
  const res = await $swoole.get(url, {
    params,
  })

  if (!res) {
    return
  }

  if (res.status === 200) {
    if (res.data.status === 'success') {
      return res.data
    }
    else {
      throw new Error(res.status)
    }
  }
  else {
    throw new Error(res.status)
  }
}

// getStandardMileageReport
// - 2023.08.16
// - get standard report mileage
export const getStandardMileageReport = async ({params}) => {
  try {
    const url = '/v1/vehicleInspection/mileage/'
    const res = await $swoole.get(url, {
      params,
    })

    if (res.status == 200){
      return res.data
    }
    else {
      throw new Error(res.status)
    }
  }
  catch (err) {
    alert(err.message || err || JSON.stringify(err))
  }
}

// getStandardMerchandise
// - 2025.02.10
// - get standard merchandise
export const getStandardMerchandise = async () => {
  try {
    const url = '/v1/other/youZanGoods'
    const res = await $swoole.get(url)

    if (res.status == 200){
      return res.data
    }
    else {
      throw new Error(res.status)
    }
  }
  catch (err) {
    alert(err.message || err || JSON.stringify(err))
  }
}

// getStandardVehicleRating
// - 2025.02.11
// - Get vehicle condition rating levels
export const getStandardVehicleRating = async ({params} = {}) => {
  try {
    const url = '/v1/filter-param-condition-levels'
    const res = await $swoole.get(url, {
      params,
    })

    if (!res) {
      return
    }

    if (res.status === 200) {
      if (res.data.status === 'success') {
        return res.data.data
      }
      else {
        throw new Error(res.data.message)
      }
    }
    else {
      throw new Error(res.status)
    }
  }
  catch (err) {
    alert(err.message || err)
  }
}

// getMomentDetailIdByCarId
// - 2024.05.31
// - Get moment detail id by car id
export const getMomentDetailIdByCarId = async ({params} = {}) => {
  try {
    const url = '/v1/nuoCircle/list'
    const body = qs.stringify(params)
    const res = await $swoole.post(url, body, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    })

    if (!res) {
      return
    }

    if (res.status === 200) {
      if (res.data.code === 2000000) {
        return res.data.data
      }

      return null
    }
    else {
      throw new Error(res.status)
    }
  }
  catch (err) {
    alert(err.message || err)
  }
}

